/**
 *
 * @param url
 * @param data {FormData|Object}
 * @param method
 * @return {Promise<any>}
 */
export default async function (url, data = null, method = "GET") {
    const config = useRuntimeConfig();

    let domain = config.public.apiDomain;
    const i18n = useNuxtApp().$i18n;
    if (i18n.defaultLocale !== i18n.locale.value) {
        const lang = i18n.locale.value;
        domain = config.public["apiDomain" + lang[0].toUpperCase() + lang.slice(1)];
    }
    url = domain + url;


    /**
     *
     * @type RequestInit
     */
    const requestInit = {
        method,
        // Поддомены (*.sharun.store) не делят localStorage друг с другом, но делят
        // cookie (SESSION_DOMAIN=.sharun.store) — credentials:'include' даёт шанс
        // бэкенду опознать уже залогиненного пользователя по cookie, даже когда
        // Id/Token-заголовков ещё нет (см. User.getInfo() — именно там токен из
        // такого ответа оседает в localStorage этого поддомена).
        credentials: "include",
    };

    if (process.client && localStorage.getItem("Id") && localStorage.getItem("Token")) {
        const headers = new Headers();
        headers.append("Id", localStorage.getItem("Id"));
        headers.append("Token", localStorage.getItem("Token"));
        requestInit.headers = headers;
    }
    if (data) {
        if (method === "POST") requestInit.body = data;
        else url += "?" + objectToSearchParams(data).toString();
    }

    let response;
    try {
        if (process.server) {
            // SSR: запрос через useFetch (POST-параметры сохраняются, ошибки не теряются).
            const {data: ssrData, error: ssrError} = await useFetch(url, requestInit);
            if (ssrError.value) {
                const status = ssrError.value.statusCode ?? ssrError.value.status;
                throw status === 429 ? "rate_limited" : "server_error";
            }
            response = ssrData.value;
        } else {
            response = await $fetch(url, requestInit);
        }
    } catch (error) {
        // Ошибки бизнес-логики приходят в теле ответа (status 0) и обрабатываются ниже.
        if (typeof error === "string") throw error;
        const status = error?.statusCode ?? error?.response?.status;
        throw status === 429 ? "rate_limited" : "server_error";
    }
    if (!response) throw "server_error";
    if (response.status === 0) throw response.data || "";
    return response.data;
}

export function objectToSearchParams(obj) {
    const searchParams = new URLSearchParams();
    for (let key in obj) {
        const values = obj[key];
        if (!values) continue;

        if (Array.isArray(values)) values.forEach(el => searchParams.append(`${key}[]`, el));
        else searchParams.set(key, values);
    }

    return searchParams;
}